function getLocation() {
  const fetchPromise = fetch(
    'https://api.ipdata.co?api-key=f334af43085d7e476aa9b7d3584f318ba7b1f251dff78df2ce24bf94',
  )
  fetchPromise
    .then(response => {
      return response.json()
    })
    .then(geo => {
      if (geo.country_name) {
        // Store in localStorage so we don't make this call again
        localStorage.setItem('country_name', geo.country_name)
        setPrice(geo.country_name)
      } else {
        // Default to USA
        localStorage.setItem('country_name', 'USA')
        setPrice('USA')
      }
    })
}

if (
  !localStorage.getItem('country_name') &&
  (window.location.search !== '?usd' || window.location.search !== '?cad')
) {
  getLocation()
} else if (window.location.search == '?usd') {
  localStorage.setItem('country_name', 'USA')
  setPrice('USA')
} else if (window.location.search == '?cad') {
  localStorage.setItem('country_name', 'Canada')
  setPrice('Canada')
} else {
  setPrice(localStorage.getItem('country_name'))
}

function setPrice(country) {
  if (country == 'Canada') {
    document.getElementById('usd-price').style.display = 'none'
    document.getElementById('usd-price-year').style.display = 'none'
    document.getElementById('usd-price-year-info').style.display = 'none'
    document.getElementById('usd-listed').style.display = 'none'
  } else {
    document.getElementById('cad-price').style.display = 'none'
    document.getElementById('cad-price-year').style.display = 'none'
    document.getElementById('cad-price-year-info').style.display = 'none'
    document.getElementById('cad-listed').style.display = 'none'
  }
}
